<div class="toast-item toast-{{ toast.type }}" [style.margin-bottom.px]="i * (60 + 16)">
  <h6 class="toast-heading" *ngIf="toast.title">{{ toast.title }}</h6>
  <p class="mb-0">{{ toast.body }}</p>
</div>
